module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-aoj_b-93dd33b73ed53fe6825d98ea3fdfbe4a.jpg";